/**
 * @generated SignedSource<<25e901bff78614c633a6f210ed73f9d1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WidgetNoteSize = "TWO_X_ONE" | "TWO_X_TWO";
export type StorecastSpacePositionInput = {
  height?: number | null;
  id: string;
  width?: number | null;
  x: number;
  y: number;
};
export type StorecastSpaceSetPositionsMutation$variables = {
  id: string;
  positions: ReadonlyArray<StorecastSpacePositionInput>;
};
export type StorecastSpaceSetPositionsMutation$data = {
  readonly storecastSpace: {
    readonly setWidgetPositions: {
      readonly id: string;
      readonly subWidgets: ReadonlyArray<{
        readonly height: number;
        readonly id: string;
        readonly note?: {
          readonly noteSize: WidgetNoteSize;
        };
        readonly noteSize?: WidgetNoteSize;
        readonly positionX: number;
        readonly positionY: number;
      }>;
    };
  } | null;
};
export type StorecastSpaceSetPositionsMutation = {
  response: StorecastSpaceSetPositionsMutation$data;
  variables: StorecastSpaceSetPositionsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "positions"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "positions",
    "variableName": "positions"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "positionX",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "positionY",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "noteSize",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StorecastSpaceSetPositionsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "StorecastSpaceMutation",
        "kind": "LinkedField",
        "name": "storecastSpace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "StorecastSpace",
            "kind": "LinkedField",
            "name": "setWidgetPositions",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "subWidgets",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Note",
                        "kind": "LinkedField",
                        "name": "note",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "WidgetNote",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StorecastSpaceSetPositionsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "StorecastSpaceMutation",
        "kind": "LinkedField",
        "name": "storecastSpace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "StorecastSpace",
            "kind": "LinkedField",
            "name": "setWidgetPositions",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "subWidgets",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Note",
                        "kind": "LinkedField",
                        "name": "note",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "WidgetNote",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b6cfa26e90b39839a4ab4f01b6775cf1",
    "id": null,
    "metadata": {},
    "name": "StorecastSpaceSetPositionsMutation",
    "operationKind": "mutation",
    "text": "mutation StorecastSpaceSetPositionsMutation(\n  $id: ID!\n  $positions: [StorecastSpacePositionInput!]!\n) {\n  storecastSpace(id: $id) {\n    setWidgetPositions(positions: $positions) {\n      id\n      subWidgets {\n        __typename\n        id\n        height\n        positionX\n        positionY\n        ... on WidgetNote {\n          noteSize\n          note {\n            noteSize\n            id\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6ade1f37da3219a67986fadf0ec18b79";

export default node;
